import '../../scss/parts/btc-dominance.scss';

(function () {
  "use strict";

  var SUPPORTED_RANGES = ["24h", "7d", "1m", "3m", "1y", "max"];
  var responseCache = new Map();
  var numberFormattersCache = new Map();
  var dateTimeFormattersCache = new Map();
  var widgets = document.querySelectorAll(".cbd-widget");
  if (!widgets.length) {
    return;
  }

  widgets.forEach(function (widget) {
    if (widget.dataset.inited === "1") {
      return;
    }

    widget.dataset.inited = "1";
    initWidget(widget);
  });

  function initWidget(widget) {
    var lang = widget.dataset.lang || "en";
    var defaultRange = widget.dataset.rangeDefault || "24h";
    var defaultSharesRange = "24h";
    var graph1 = widget.querySelector('[data-graph="btc-dominance"]');
    var graph2 = widget.querySelector('[data-graph="market-shares"]');
    var btcTabs = widget.querySelectorAll('.cbd-range-tab[data-scope="btc"]');
    var sharesTabs = widget.querySelectorAll('.cbd-range-tab[data-scope="shares"]');
    var noDataText = getNoDataText(graph1);

    hydrateUpdatedLabel(widget, lang);

    if (!graph1 || !graph2) {
      return;
    }

    var initialRange = widget.dataset.initialRange || defaultRange;
    var initialPayloadMap = readInitialPayloadMap(widget);
    primeInitialPayloadMap(lang, initialPayloadMap);
    var initialPayload =
      (initialPayloadMap &&
      Object.prototype.hasOwnProperty.call(initialPayloadMap, initialRange) &&
      initialPayloadMap[initialRange] &&
      typeof initialPayloadMap[initialRange] === "object")
        ? initialPayloadMap[initialRange]
        : readInitialPayload(widget);
    widget.__cbdInitialPayload = initialPayload;
    widget.__cbdInitialRange = initialRange;

    if (initialPayload && hasSeriesData(initialPayload) && SUPPORTED_RANGES.indexOf(initialRange) !== -1) {
      responseCache.set(buildRequestKey(lang, initialRange), initialPayload);
    }

    widget.__cbdSharesLoaded = false;
    widget.__cbdSharesRange = defaultSharesRange;

    if (SUPPORTED_RANGES.indexOf(defaultRange) === -1) {
      defaultRange = "24h";
    }

    btcTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var range = tab.dataset.range || "24h";
        if (SUPPORTED_RANGES.indexOf(range) === -1) {
          return;
        }

        activateTab(btcTabs, range);
        loadBtcRange(widget, lang, range, graph1, noDataText);
      });
    });

    sharesTabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var range = tab.dataset.range || "24h";
        if (SUPPORTED_RANGES.indexOf(range) === -1) {
          return;
        }

        activateTab(sharesTabs, range);
        widget.__cbdSharesRange = range;
        ensureSharesLoaded(widget, lang, range, graph2, noDataText);
      });
    });

    activateTab(btcTabs, defaultRange);
    activateTab(sharesTabs, defaultSharesRange);
    if (initialPayload && hasSeriesData(initialPayload) && initialRange === defaultRange) {
      applyBtcPayload(widget, initialPayload, lang, defaultRange, graph1, noDataText);
    } else {
      loadBtcRange(widget, lang, defaultRange, graph1, noDataText);
    }
    setupLazySharesLoad(widget, lang, graph2, noDataText);
    scheduleHistoricalTableLoad(widget, lang);
  }

  function ensureSharesLoaded(widget, lang, range, graph2, noDataText) {
    widget.__cbdSharesLoaded = true;
    if (widget.__cbdInitialPayload && hasSeriesData(widget.__cbdInitialPayload) && widget.__cbdInitialRange === range) {
      applySharesPayload(widget, widget.__cbdInitialPayload, lang, range, graph2, noDataText);
      return;
    }
    loadSharesRange(widget, lang, range, graph2, noDataText);
  }

  function setupLazySharesLoad(widget, lang, graph2, noDataText) {
    var defaultRange = widget.__cbdSharesRange || "24h";

    if (typeof window.IntersectionObserver === "function") {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || widget.__cbdSharesLoaded) {
              return;
            }
            ensureSharesLoaded(widget, lang, defaultRange, graph2, noDataText);
            observer.disconnect();
          });
        },
        { rootMargin: "180px 0px" }
      );
      observer.observe(graph2);
      return;
    }

    window.setTimeout(function () {
      if (widget.__cbdSharesLoaded) {
        return;
      }
      ensureSharesLoaded(widget, lang, defaultRange, graph2, noDataText);
    }, 700);
  }

  function activateTab(tabs, activeRange) {
    tabs.forEach(function (tab) {
      var isActive = tab.dataset.range === activeRange;
      tab.classList.toggle("cbd-range-tab--active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  }

  function loadBtcRange(widget, lang, range, graph1, noDataText) {
    showGraphMessage(graph1, widget.dataset.labelLoading || loadingText(lang));

    fetchRange(lang, range)
      .then(function (payload) {
        applyBtcPayload(widget, payload, lang, range, graph1, noDataText);
      })
      .catch(function () {
        var fallback = getCachedPayload(lang, range);
        if (fallback) {
          applyBtcPayload(widget, fallback, lang, range, graph1, noDataText);
          return;
        }
        showGraphMessage(graph1, noDataText);
      });
  }

  function loadSharesRange(widget, lang, range, graph2, noDataText) {
    showGraphMessage(graph2, widget.dataset.labelLoading || loadingText(lang));
    renderSharesSummary(widget, null, lang);

    fetchRange(lang, range)
      .then(function (payload) {
        applySharesPayload(widget, payload, lang, range, graph2, noDataText);
      })
      .catch(function () {
        var fallback = getCachedPayload(lang, range);
        if (fallback) {
          applySharesPayload(widget, fallback, lang, range, graph2, noDataText);
          return;
        }
        showGraphMessage(graph2, noDataText);
        renderSharesSummary(widget, null, lang);
      });
  }

  function applyBtcPayload(widget, payload, lang, range, graph1, noDataText) {
    updateCards(widget, payload, lang);

    var timestamps =
      payload && payload.series && Array.isArray(payload.series.timestamps)
        ? payload.series.timestamps
        : [];
    var btcPct = extractSeries(payload, "btc_pct");
    updateBtcFromSeries(widget, btcPct, payload && payload.cards ? payload.cards : null, range, lang);
    updateDynamicHighLow(widget, timestamps, btcPct, range, lang);
    renderBtcChart(graph1, timestamps, btcPct, lang, range, noDataText);
  }

  function applySharesPayload(widget, payload, lang, range, graph2, noDataText) {
    var timestamps =
      payload && payload.series && Array.isArray(payload.series.timestamps)
        ? payload.series.timestamps
        : [];
    var btcPct = extractSeries(payload, "btc_pct");
    var ethPct = extractSeries(payload, "eth_pct");
    var stablePct = extractSeries(payload, "stable_pct");
    var othersPct = extractSeries(payload, "others_pct");

    renderStackedSharesChart(
      graph2,
      timestamps,
      btcPct,
      ethPct,
      stablePct,
      othersPct,
      lang,
      range,
      noDataText
    );
    var latest = latestShares(btcPct, ethPct, stablePct, othersPct);
    renderSharesSummary(widget, latest ? normalizeShares(latest) : null, lang);
  }

  function readInitialPayload(widget) {
    var node = widget.querySelector('[data-field="initial-payload"]');
    if (!node || !node.textContent) {
      return null;
    }
    try {
      var parsed = JSON.parse(node.textContent);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function hydrateUpdatedLabel(widget, lang) {
    var node = widget.querySelector('[data-field="updated-text"]');
    if (!node) {
      return;
    }

    var iso = node.getAttribute("data-updated-at");
    if (!iso) {
      return;
    }

    var date = new Date(String(iso));
    if (isNaN(date.getTime())) {
      return;
    }

    var updatedLabel = widget.dataset.labelUpdated || "Updated";
    node.textContent = updatedLabel + ": " + formatDateTime(date, lang || widget.dataset.lang || "en");
  }

  function readInitialPayloadMap(widget) {
    var node = widget.querySelector('[data-field="initial-payload-map"]');
    if (!node || !node.textContent) {
      return null;
    }
    try {
      var parsed = JSON.parse(node.textContent);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function primeInitialPayloadMap(lang, payloadMap) {
    if (!payloadMap || typeof payloadMap !== "object") {
      return;
    }
    SUPPORTED_RANGES.forEach(function (range) {
      var payload = payloadMap[range];
      if (!payload || typeof payload !== "object") {
        return;
      }
      if (!hasSeriesData(payload)) {
        return;
      }
      responseCache.set(buildRequestKey(lang, range), payload);
    });
  }

  function hasSeriesData(payload) {
    if (!payload || typeof payload !== "object") {
      return false;
    }
    var series = payload.series;
    if (!series || !Array.isArray(series.timestamps)) {
      return false;
    }
    return series.timestamps.length > 0;
  }

  function fetchRange(lang, range) {
    var payload = getCachedPayload(lang, range);
    if (payload) {
      return Promise.resolve(payload);
    }
    return Promise.reject(new Error("missing_cached_payload"));
  }

  function loadHistoricalDominanceTable(widget, lang) {
    var periods = ["24h", "7d", "1m", "3m", "1y"];
    fetchTablePeriodsParallel(lang, periods).then(function (results) {
      renderHistoricalTable(widget, results, lang);
    });
  }

  function fetchTablePeriodsParallel(lang, periods) {
    return Promise.all(
      periods.map(function (period) {
        return fetchRange(lang, period)
          .then(function (payload) {
            return periodSharesValue(payload);
          })
          .catch(function () {
            var fallback = getCachedPayload(lang, period);
            return fallback ? periodSharesValue(fallback) : null;
          });
      })
    );
  }

  function periodSharesValue(payload) {
    var btcPct = extractSeries(payload, "btc_pct");
    var ethPct = extractSeries(payload, "eth_pct");
    var stablePct = extractSeries(payload, "stable_pct");
    var othersPct = extractSeries(payload, "others_pct");
    var latest = latestShares(btcPct, ethPct, stablePct, othersPct);
    return latest ? normalizeShares(latest) : null;
  }

  function scheduleHistoricalTableLoad(widget, lang) {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(
        function () {
          loadHistoricalDominanceTable(widget, lang);
        },
        { timeout: 700 }
      );
      return;
    }
    window.setTimeout(function () {
      loadHistoricalDominanceTable(widget, lang);
    }, 250);
  }

  function renderHistoricalTable(widget, periodValues, lang) {
    var rows = [
      { key: "btc", label: assetLabel(lang, "btc"), color: shareColor("btc") },
      { key: "eth", label: assetLabel(lang, "eth"), color: shareColor("eth") },
      { key: "stable", label: assetLabel(lang, "stable"), color: shareColor("stable") },
      { key: "others", label: assetLabel(lang, "others"), color: shareColor("others") },
    ];

    var html = rows
      .map(function (row) {
        var cols = periodValues
          .map(function (value) {
            if (!value) {
              return "<td>--%</td>";
            }
            return "<td>" + formatNumber(value[row.key], lang, 2, 2) + "%</td>";
          })
          .join("");

        return (
          "<tr>" +
          '<td><span class="cbd-share-dot" style="background:' +
          row.color +
          '"></span>' +
          row.label +
          "</td>" +
          cols +
          "</tr>"
        );
      })
      .join("");

    setHtml(widget, "history-table-body", html);
  }

  function buildRequestKey(lang, range) {
    return String(lang) + "::" + String(range);
  }

  function getCachedPayload(lang, range) {
    var key = buildRequestKey(lang, range);
    return responseCache.get(key) || null;
  }

  function extractSeries(payload, key) {
    return payload && payload.series && Array.isArray(payload.series[key]) ? payload.series[key] : [];
  }

  function updateCards(widget, payload, lang) {
    var cards = payload && payload.cards ? payload.cards : null;
    if (!cards) {
      return;
    }

    setText(widget, "btc-high-365", formatPct(cards.btc_high_365, lang));
    setText(widget, "btc-low-365", formatPct(cards.btc_low_365, lang));
    setText(widget, "btc-high-365-date", formatDate(cards.btc_high_365_date, lang));
    setText(widget, "btc-low-365-date", formatDate(cards.btc_low_365_date, lang));

    var updatedLabel = widget.dataset.labelUpdated || "Updated";
    var updatedAt = payload && payload.updated_at ? payload.updated_at : "";

    setText(
      widget,
      "updated-text",
      updatedLabel + ": " + formatDateTime(updatedAt, lang)
    );
  }

  function updateBtcFromSeries(widget, btcSeries, cards, range, lang) {
    var values = btcSeries
      .map(function (v) {
        return toNumber(v);
      })
      .filter(function (v) {
        return v !== null;
      });
    if (!values.length) {
      setText(widget, "btc-range-change", "");
      return;
    }

    var current = values[values.length - 1];
    var change = null;
    if (cards && range === "24h") {
      change = toNumber(cards.btc_delta_24h_pp);
    } else if (cards && range === "7d") {
      change = toNumber(cards.btc_delta_7d_pp);
    } else {
      var first = values[0];
      change = current - first;
    }

    setText(widget, "btc-now", formatPct(current, lang));
    updateBtcChangePill(widget, change, lang);
  }

  function updateBtcChangePill(widget, change, lang) {
    var node = widget.querySelector('[data-field="btc-range-change"]');
    if (!node) {
      return;
    }
    if (!Number.isFinite(change) || change === 0) {
      node.textContent = "";
      node.classList.remove("cbd-change-pill--up", "cbd-change-pill--down");
      return;
    }

    var arrow = change > 0 ? "▲ " : "▼ ";
    node.textContent = arrow + formatNumber(Math.abs(change), lang, 2, 2) + "%";
    node.classList.remove("cbd-change-pill--up", "cbd-change-pill--down");
    node.classList.add(change > 0 ? "cbd-change-pill--up" : "cbd-change-pill--down");
  }

  function updateDynamicHighLow(widget, timestamps, btcSeries, range, lang) {
    var points = [];
    var len = Math.min(timestamps.length, btcSeries.length);
    for (var i = 0; i < len; i++) {
      var ts = Number(timestamps[i]);
      var val = toNumber(btcSeries[i]);
      if (!Number.isFinite(ts) || val === null) continue;
      points.push({ ts: ts, value: val });
    }

    if (!points.length) return;

    var maxPoint = points[0];
    var minPoint = points[0];
    for (var j = 1; j < points.length; j++) {
      if (points[j].value > maxPoint.value) maxPoint = points[j];
      if (points[j].value < minPoint.value) minPoint = points[j];
    }

    setText(widget, "max-min-title", maxMinTitle(range, lang));
    setText(widget, "btc-high-365", formatPct(maxPoint.value, lang));
    setText(widget, "btc-low-365", formatPct(minPoint.value, lang));
    setText(
      widget,
      "btc-high-365-date",
      formatPointDate(maxPoint.ts, lang, range === "24h")
    );
    setText(
      widget,
      "btc-low-365-date",
      formatPointDate(minPoint.ts, lang, range === "24h")
    );
  }

  function setText(widget, field, value) {
    var node = widget.querySelector('[data-field="' + field + '"]');
    if (!node) {
      return;
    }
    node.textContent = value;
  }

  function setHtml(widget, field, value) {
    var node = widget.querySelector('[data-field="' + field + '"]');
    if (!node) {
      return;
    }
    node.innerHTML = value;
  }

  function renderSharesSummary(widget, normalized, lang) {
    var labels = getShareLabels(lang);
    var values = normalized || { btc: null, eth: null, stable: null, others: null };
    var html = [
      renderShareItem(labels.btc, values.btc, lang, "btc"),
      renderShareItem(labels.eth, values.eth, lang, "eth"),
      renderShareItem(labels.stable, values.stable, lang, "stable"),
      renderShareItem(labels.others, values.others, lang, "others"),
    ].join("");
    setHtml(widget, "shares-now-summary", html);
  }

  function renderShareItem(label, value, lang, kind) {
    var color = shareColor(kind);
    var text = value === null ? "--%" : formatNumber(value, lang, 2, 2) + "%";
    return (
      '<span class="cbd-share-item">' +
      '<span class="cbd-share-dot" style="background:' + color + '"></span>' +
      label +
      " - " +
      text +
      "</span>"
    );
  }

  function shareColor(kind) {
    switch (kind) {
      case "btc":
        return "#f59e0b";
      case "eth":
        return "#3b82f6";
      case "stable":
        return "#10b981";
      default:
        return "#94a3b8";
    }
  }

  function formatPct(value, lang) {
    var n = toNumber(value);
    if (n === null) {
      return "--.--%";
    }
    return formatNumber(n, lang, 2, 2) + "%";
  }

  function formatDate(value, lang) {
    if (!value) {
      return "----";
    }
    var asDate = new Date(String(value) + "T00:00:00Z");
    if (isNaN(asDate.getTime())) {
      return "----";
    }
    return getDateTimeFormatter(resolveLocale(lang), {
      year: "numeric",
      month: "short",
      day: "2-digit",
      timeZone: "UTC",
    }).format(asDate);
  }

  function formatDateTime(value, lang) {
    var asDate = value ? new Date(String(value)) : new Date();
    if (isNaN(asDate.getTime())) {
      return "--";
    }
    var locale = resolveLocale(lang);
    var formatted = getDateTimeFormatter(locale, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(asDate);
    return formatted + " (UTC" + utcOffsetLabel(asDate) + ")";
  }

  function resolveLocale(lang) {
    var normalized = String(lang || "").toLowerCase();
    if (normalized === "ru") return "ru-RU";
    if (normalized === "en") return "en-US";
    if (normalized === "pl") return "pl-PL";
    if (normalized === "es") return "es-ES";
    if (normalized === "ro") return "ro-RO";
    if (normalized === "tr") return "tr-TR";

    if (typeof navigator !== "undefined") {
      if (Array.isArray(navigator.languages) && navigator.languages.length) {
        return navigator.languages[0];
      }
      if (navigator.language) {
        return navigator.language;
      }
    }
    return lang || "en";
  }

  function utcOffsetLabel(date) {
    var offsetMin = -date.getTimezoneOffset();
    if (!Number.isFinite(offsetMin) || offsetMin === 0) {
      return "";
    }
    var sign = offsetMin >= 0 ? "+" : "-";
    var abs = Math.abs(offsetMin);
    var hh = Math.floor(abs / 60);
    var mm = abs % 60;
    if (mm === 0) {
      return sign + hh;
    }
    return sign + hh + ":" + String(mm).padStart(2, "0");
  }

  function maxMinTitle(range, lang) {
    var normalized = String(lang || "").toLowerCase();
    var map = {
      ru: {
        "24h": "Максимум и минимум за 24 часа",
        "7d": "Максимум и минимум за 7 дней",
        "1m": "Максимум и минимум за 1 месяц",
        "3m": "Максимум и минимум за 3 месяца",
        "1y": "Максимум и минимум за 1 год",
        max: "Максимум и минимум за все время",
      },
      tr: {
        "24h": "24 saat icin maksimum ve minimum",
        "7d": "7 gun icin maksimum ve minimum",
        "1m": "1 ay icin maksimum ve minimum",
        "3m": "3 ay icin maksimum ve minimum",
        "1y": "1 yil icin maksimum ve minimum",
        max: "Tum zamanlar maksimum ve minimum",
      },
      pl: {
        "24h": "Maksimum i minimum za 24 godziny",
        "7d": "Maksimum i minimum za 7 dni",
        "1m": "Maksimum i minimum za 1 miesiac",
        "3m": "Maksimum i minimum za 3 miesiace",
        "1y": "Maksimum i minimum za 1 rok",
        max: "Maksimum i minimum za caly okres",
      },
      es: {
        "24h": "Maximo y minimo en 24 horas",
        "7d": "Maximo y minimo en 7 dias",
        "1m": "Maximo y minimo en 1 mes",
        "3m": "Maximo y minimo en 3 meses",
        "1y": "Maximo y minimo en 1 ano",
        max: "Maximo y minimo historico",
      },
      ro: {
        "24h": "Maxim si minim in 24 ore",
        "7d": "Maxim si minim in 7 zile",
        "1m": "Maxim si minim in 1 luna",
        "3m": "Maxim si minim in 3 luni",
        "1y": "Maxim si minim in 1 an",
        max: "Maxim si minim pentru toata perioada",
      },
      en: {
        "24h": "High and low in 24h",
        "7d": "High and low in 7d",
        "1m": "High and low in 1m",
        "3m": "High and low in 3m",
        "1y": "High and low in 1y",
        max: "High and low all time",
      },
    };
    var langMap = map[normalized] || map.en;
    return langMap[range] || langMap["7d"] || "High and low";
  }

  function formatPointDate(ts, lang, withTime) {
    var date = new Date(ts);
    if (isNaN(date.getTime())) return "----";
    var locale = resolveLocale(lang);
    if (withTime) {
      return (
        getDateTimeFormatter(locale, {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }).format(date) +
        " UTC" +
        utcOffsetLabel(date)
      );
    }

    return getDateTimeFormatter(locale, {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(date);
  }

  function formatSignedNumber(value, lang, digits) {
    var n = Number(value);
    return getNumberFormatter(resolveLocale(lang), {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      signDisplay: "always",
    }).format(n);
  }

  function formatNumber(value, lang, min, max) {
    var n = Number(value);
    return getNumberFormatter(resolveLocale(lang), {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    }).format(n);
  }

  function toNumber(value) {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    var n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function renderBtcChart(graph, timestamps, btcSeries, lang, range, noDataText) {
    var points = [];
    var len = Math.min(timestamps.length, btcSeries.length);
    for (var i = 0; i < len; i++) {
      var ts = Number(timestamps[i]);
      var value = btcSeries[i];
      if (!Number.isFinite(ts) || value === null || value === undefined) {
        continue;
      }

      var num = Number(value);
      if (!Number.isFinite(num)) {
        continue;
      }
      points.push({ ts: ts, value: num });
    }

    if (!points.length) {
      showGraphMessage(graph, noDataText);
      return;
    }


    var chart = ensureChartUi(graph);
    var canvas = chart.canvas;
    var tooltip = chart.tooltip;
    var hoverState = { index: null, value: null };

    function draw() {
      drawLineAreaChart(canvas, points, lang, range, hoverState);
    }

    draw();
    bindChartResize(graph, draw);

    bindTooltip(canvas, tooltip, points, lang, function (nextState) {
      hoverState.index = nextState.index;
      hoverState.value = nextState.value;
      draw();
    });
  }

  function renderStackedSharesChart(
    graph,
    timestamps,
    btcPct,
    ethPct,
    stablePct,
    othersPct,
    lang,
    range,
    noDataText
  ) {
    var points = [];
    var len = Math.min(
      timestamps.length,
      btcPct.length,
      ethPct.length,
      stablePct.length,
      othersPct.length
    );
    for (var i = 0; i < len; i++) {
      if (
        btcPct[i] === null ||
        ethPct[i] === null ||
        stablePct[i] === null ||
        othersPct[i] === null
      ) {
        continue;
      }

      var ts = Number(timestamps[i]);
      var btc = Number(btcPct[i]);
      var eth = Number(ethPct[i]);
      var stable = Number(stablePct[i]);
      var others = Number(othersPct[i]);
      if (!Number.isFinite(ts) || !Number.isFinite(btc) || !Number.isFinite(eth) || !Number.isFinite(stable) || !Number.isFinite(others)) {
        continue;
      }

      points.push({
        ts: ts,
        btc: btc,
        eth: eth,
        stable: stable,
        others: others,
      });
    }

    if (!points.length) {
      showGraphMessage(graph, noDataText);
      return;
    }

    var chart = ensureChartUi(graph);
    var canvas = chart.canvas;
    var tooltip = chart.tooltip;
    var hoverState = { index: null, layer: null, cumValue: null };

    function draw() {
      drawStackedAreaChart(canvas, points, lang, range, hoverState);
    }
    draw();
    bindChartResize(graph, draw);

    bindStackedTooltip(canvas, tooltip, points, lang, function (nextState) {
      hoverState.index = nextState.index;
      hoverState.layer = nextState.layer;
      hoverState.cumValue = nextState.cumValue;
      draw();
    });
  }

  function ensureChartUi(graph) {
    var canvas = graph.querySelector("canvas.cbd-chart-canvas");
    var tooltip = graph.querySelector(".cbd-chart-tooltip");
    var titleHtml = getGraphTitleHtml(graph);

    graph.classList.add("cbd-graph--chart");

    if (!canvas) {
      graph.innerHTML = titleHtml;
      canvas = document.createElement("canvas");
      canvas.className = "cbd-chart-canvas";
      canvas.setAttribute("aria-label", "BTC dominance chart");
      graph.appendChild(canvas);
    }

    if (!tooltip) {
      tooltip = document.createElement("div");
      tooltip.className = "cbd-chart-tooltip";
      graph.appendChild(tooltip);
    }

    return { canvas: canvas, tooltip: tooltip };
  }

  function drawLineAreaChart(canvas, points, lang, range, hoverState) {
    var ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }

    var rect = canvas.parentElement.getBoundingClientRect();
    var width = Math.max(280, Math.floor(rect.width - 20));
    var height = 300;
    var dpr = window.devicePixelRatio || 1;

    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var isMobile = width < 480;
    var pad = chartPad(width);
    var minTs = points[0].ts;
    var maxTs = points[points.length - 1].ts;
    var domain = Math.max(1, maxTs - minTs);
    var plotWidth = width - pad.left - pad.right;
    var plotHeight = height - pad.top - pad.bottom;

    function x(ts) {
      return pad.left + ((ts - minTs) / domain) * plotWidth;
    }
    function y(value) {
      var clamped = Math.max(0, Math.min(100, value));
      return pad.top + ((100 - clamped) / 100) * plotHeight;
    }

    ctx.clearRect(0, 0, width, height);

    ctx.font = (isMobile ? "10px" : "12px") + " sans-serif";
    ctx.fillStyle = "#6b7280";
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    ctx.strokeStyle = "#e5e7eb";
    ctx.lineWidth = 1;
    [0, 25, 50, 75, 100].forEach(function (tick) {
      var py = y(tick);
      ctx.beginPath();
      ctx.moveTo(pad.left, py);
      ctx.lineTo(width - pad.right, py);
      ctx.stroke();
      ctx.fillText(tick + "%", width - pad.right + 6, py);
    });

    var baseY = y(0);

    ctx.beginPath();
    points.forEach(function (p, idx) {
      var px = x(p.ts);
      var py = y(p.value);
      if (idx === 0) {
        ctx.moveTo(px, py);
      } else {
        ctx.lineTo(px, py);
      }
    });
    ctx.lineTo(x(points[points.length - 1].ts), baseY);
    ctx.lineTo(x(points[0].ts), baseY);
    ctx.closePath();
    ctx.fillStyle = "rgba(37, 99, 235, 0.18)";
    ctx.fill();

    ctx.beginPath();
    points.forEach(function (p, idx) {
      var px = x(p.ts);
      var py = y(p.value);
      if (idx === 0) {
        ctx.moveTo(px, py);
      } else {
        ctx.lineTo(px, py);
      }
    });
    ctx.strokeStyle = "#2563eb";
    ctx.lineWidth = 2;
    ctx.stroke();

    if (hoverState && hoverState.index !== null && hoverState.index >= 0 && hoverState.index < points.length) {
      var hp = points[hoverState.index];
      var hx = x(hp.ts);
      var hy = y(hoverState.value === null ? hp.value : hoverState.value);
      ctx.fillStyle = "#ffffff";
      ctx.beginPath();
      ctx.arc(hx, hy, 6, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = "#2563eb";
      ctx.lineWidth = 1.5;
      ctx.stroke();
    }

    drawXAxisTicks(ctx, points, pad, width, height, range, lang);
  }

  function drawXAxisTicks(ctx, points, pad, width, height, range, lang) {
    var plotWidth = width - pad.left - pad.right;
    var isMobile = width < 480;
    var minLabelSpacing = range === "24h" ? 64 : 88;
    var maxTickCount = Math.max(3, Math.min(8, Math.floor(plotWidth / minLabelSpacing)));
    if (isMobile && range === "1y") {
      maxTickCount = 2;
    }
    var ticks = buildXAxisTicks(points, range, maxTickCount);
    if (!ticks.length) {
      return;
    }

    var minTs = points[0].ts;
    var maxTs = points[points.length - 1].ts;
    var domain = Math.max(1, maxTs - minTs);
    var x = function (ts) {
      return pad.left + ((ts - minTs) / domain) * plotWidth;
    };

    ctx.strokeStyle = "#d1d5db";
    ctx.fillStyle = "#6b7280";
    ctx.font = "11px sans-serif";
    ctx.textBaseline = "top";

    ticks.forEach(function (tick) {
      var px = x(tick.ts);
      var py = height - pad.bottom;
      var text = formatXAxisLabel(tick.ts, range, lang);
      var textWidth = ctx.measureText(text).width;
      var half = textWidth / 2;
      var leftEdge = pad.left;
      var rightEdge = width - pad.right - 4;

      var drawX = px;
      if (drawX - half < leftEdge) {
        drawX = leftEdge + half;
      } else if (drawX + half > rightEdge) {
        drawX = rightEdge - half;
      }

      ctx.beginPath();
      ctx.moveTo(px, py);
      ctx.lineTo(px, py + 4);
      ctx.stroke();
      ctx.textAlign = "center";
      ctx.fillText(text, drawX, py + 6);
    });
  }

  function buildXAxisTicks(points, range, maxTickCount) {
    if (!points.length) {
      return [];
    }

    if (range === "max") {
      return buildYearTicks(points, 2, maxTickCount);
    }

    return buildUniformTicks(points, maxTickCount);
  }

  function buildUniformTicks(points, maxTickCount) {
    if (!points.length) {
      return [];
    }
    var first = points[0].ts;
    var last = points[points.length - 1].ts;
    if (maxTickCount <= 1 || last <= first) {
      return [{ ts: first }, { ts: last }];
    }

    var ticks = [];
    for (var i = 0; i < maxTickCount; i++) {
      var ratio = i / (maxTickCount - 1);
      ticks.push({ ts: Math.round(first + (last - first) * ratio) });
    }
    return uniqueTicks(ticks);
  }

  function buildYearTicks(points, yearStep, maxTickCount) {
    var firstDate = new Date(points[0].ts);
    var lastDate = new Date(points[points.length - 1].ts);
    var startYear = firstDate.getUTCFullYear();
    var endYear = lastDate.getUTCFullYear();
    var ticks = [];

    for (var year = startYear; year <= endYear; year += yearStep) {
      var targetTs = Date.UTC(year, 0, 1, 0, 0, 0, 0);
      var candidate = nearestPointAtOrAfter(points, targetTs);
      if (candidate !== null) {
        ticks.push({ ts: candidate });
      }
    }

    var lastTs = points[points.length - 1].ts;
    if (!ticks.length || ticks[ticks.length - 1].ts !== lastTs) {
      ticks.push({ ts: lastTs });
    }

    return limitTickCount(uniqueTicks(ticks), maxTickCount);
  }

  function nearestPointAtOrAfter(points, targetTs) {
    for (var i = 0; i < points.length; i++) {
      if (points[i].ts >= targetTs) {
        return points[i].ts;
      }
    }
    return null;
  }

  function uniqueTicks(ticks) {
    var seen = {};
    return ticks.filter(function (tick) {
      var key = String(tick.ts);
      if (seen[key]) {
        return false;
      }
      seen[key] = true;
      return true;
    });
  }

  function limitTickCount(ticks, maxCount) {
    if (ticks.length <= maxCount) {
      return ticks;
    }
    var result = [];
    for (var i = 0; i < maxCount; i++) {
      var idx = Math.floor((i * (ticks.length - 1)) / (maxCount - 1));
      result.push(ticks[idx]);
    }
    return uniqueTicks(result);
  }

  function xStepMs(range) {
    var hour = 60 * 60 * 1000;
    var day = 24 * hour;
    switch (range) {
      case "24h":
        return hour;
      case "7d":
        return day;
      case "1m":
        return 5 * day;
      case "3m":
        return 10 * day;
      case "1y":
        return 30 * day;
      default:
        return day;
    }
  }

  function formatXAxisLabel(ts, range, lang) {
    var date = new Date(ts);
    var locale = resolveLocale(lang);
    if (range === "24h") {
      return getDateTimeFormatter(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC",
      }).format(date);
    }

    if (range === "max") {
      return getDateTimeFormatter(locale, {
        year: "numeric",
        timeZone: "UTC",
      }).format(date);
    }

    if (range === "7d" || range === "1m" || range === "3m") {
      return getDateTimeFormatter(locale, {
        day: "2-digit",
        month: "short",
        timeZone: "UTC",
      }).format(date);
    }

    return getDateTimeFormatter(locale, {
      day: "2-digit",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
    }).format(date);
  }

  function drawStackedAreaChart(canvas, points, lang, range, hoverState) {
    var ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }

    var rect = canvas.parentElement.getBoundingClientRect();
    var width = Math.max(280, Math.floor(rect.width - 20));
    var height = 300;
    var dpr = window.devicePixelRatio || 1;

    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var isMobile = width < 480;
    var pad = chartPad(width);
    var minTs = points[0].ts;
    var maxTs = points[points.length - 1].ts;
    var domain = Math.max(1, maxTs - minTs);
    var plotWidth = width - pad.left - pad.right;
    var plotHeight = height - pad.top - pad.bottom;

    function x(ts) {
      return pad.left + ((ts - minTs) / domain) * plotWidth;
    }
    function y(value) {
      var clamped = Math.max(0, Math.min(100, value));
      return pad.top + ((100 - clamped) / 100) * plotHeight;
    }

    ctx.clearRect(0, 0, width, height);
    ctx.font = (isMobile ? "10px" : "12px") + " sans-serif";
    ctx.fillStyle = "#6b7280";
    ctx.textAlign = "left";
    ctx.textBaseline = "middle";
    ctx.strokeStyle = "#e5e7eb";
    ctx.lineWidth = 1;
    [0, 25, 50, 75, 100].forEach(function (tick) {
      var py = y(tick);
      ctx.beginPath();
      ctx.moveTo(pad.left, py);
      ctx.lineTo(width - pad.right, py);
      ctx.stroke();
      ctx.fillText(tick + "%", width - pad.right + 6, py);
    });

    var layers = [
      { key: "btc", color: "rgba(245, 158, 11, 0.55)" },
      { key: "eth", color: "rgba(59, 130, 246, 0.45)" },
      { key: "stable", color: "rgba(16, 185, 129, 0.45)" },
      { key: "others", color: "rgba(148, 163, 184, 0.45)" },
    ];

    var lower = new Array(points.length).fill(0);
    layers.forEach(function (layer) {
      var upper = points.map(function (p, idx) {
        return lower[idx] + p[layer.key];
      });

      ctx.beginPath();
      points.forEach(function (p, idx) {
        var px = x(p.ts);
        var py = y(upper[idx]);
        if (idx === 0) {
          ctx.moveTo(px, py);
        } else {
          ctx.lineTo(px, py);
        }
      });
      for (var i = points.length - 1; i >= 0; i--) {
        ctx.lineTo(x(points[i].ts), y(lower[i]));
      }
      ctx.closePath();
      ctx.fillStyle = layer.color;
      ctx.fill();

      lower = upper;
    });

    if (hoverState && hoverState.index !== null && hoverState.index >= 0 && hoverState.index < points.length) {
      var hoverPoint = points[hoverState.index];
      var markerX = x(hoverPoint.ts);
      var markerY = y(hoverState.cumValue === null ? 0 : hoverState.cumValue);
      var markerColor = shareColor(hoverState.layer || "others");


      ctx.beginPath();
      ctx.arc(markerX, markerY, 6, 0, Math.PI * 2);
      ctx.fillStyle = "#ffffff";
      ctx.fill();
      
      ctx.strokeStyle = markerColor;
      ctx.lineWidth = 1.5;
      ctx.stroke();

      /*
      ctx.fillStyle = markerColor;
      ctx.beginPath();
      ctx.arc(markerX, markerY, 4, 0, Math.PI * 2);
      ctx.fill();

      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 1.5;
      ctx.stroke();
      */
    }

    drawXAxisTicks(ctx, points, pad, width, height, range, lang);
  }

  function bindTooltip(canvas, tooltip, points, lang, onHover) {
    var parent = canvas.parentElement;
    var locale = resolveLocale(lang);
    var dateFmt = getDateTimeFormatter(locale, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      timeZone: "UTC",
    });
    var pctFmt = getNumberFormatter(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    function valueToY(value, rect) {
      var pad = chartPad(rect.width);
      var plotHeight = rect.height - pad.top - pad.bottom;
      var clamped = Math.max(0, Math.min(100, value));
      return pad.top + ((100 - clamped) / 100) * plotHeight;
    }

    function onMove(event) {
      var rect = canvas.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var index = Math.round((x / Math.max(1, rect.width)) * (points.length - 1));
      index = Math.max(0, Math.min(points.length - 1, index));
      var point = points[index];
      if (!point) {
        tooltip.style.opacity = "0";
        onHover({ index: null, value: null });
        return;
      }

      //tooltip.textContent =
      //  dateFmt.format(new Date(point.ts)) + " - BTC " + pctFmt.format(point.value) + "%";

      tooltip.innerHTML =
        '<div class="cbd-tooltip-date">' + dateFmt.format(new Date(point.ts)) + "</div>" +
        '<div class="cbd-tooltip-row">BTC: <span>' + pctFmt.format(point.value) + "%</span></div>";

      tooltip.style.opacity = "1";
      var pad = chartPad(rect.width);
      var plotWidth = rect.width - pad.left - pad.right;
      var pointX = pad.left + (index / Math.max(1, points.length - 1)) * plotWidth;
      var pointY = valueToY(point.value, rect);
      positionTooltip(tooltip, rect, pointX, pointY);
      //positionTooltip(tooltip, rect, x, valueToY(point.value, rect) - 32);
      onHover({ index: index, value: point.value });
    }

    function onLeave() {
      tooltip.style.opacity = "0";
      onHover({ index: null, value: null });
    }

    parent.onmousemove = onMove;
    parent.onmouseleave = onLeave;
  }

  function bindStackedTooltip(canvas, tooltip, points, lang, onHover) {
    var parent = canvas.parentElement;
    var labels = getShareLabels(lang);
    var locale = resolveLocale(lang);
    var dateFmt = getDateTimeFormatter(locale, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      timeZone: "UTC",
    });
    var pctFmt = getNumberFormatter(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    function valueToY(value, rect) {
      var pad = chartPad(rect.width);
      var plotHeight = rect.height - pad.top - pad.bottom;
      var clamped = Math.max(0, Math.min(100, value));
      return pad.top + ((100 - clamped) / 100) * plotHeight;
    }

    function detectLayer(point, mouseY, rect) {
      var p = chartPad(rect.width);
      var yPct = 100 - ((mouseY - p.top) / Math.max(1, rect.height - p.top - p.bottom)) * 100;
      yPct = Math.max(0, Math.min(100, yPct));
      var b1 = point.btc;
      var b2 = point.btc + point.eth;
      var b3 = b2 + point.stable;
      if (yPct <= b1) return "btc";
      if (yPct <= b2) return "eth";
      if (yPct <= b3) return "stable";
      return "others";
    }

    function onMove(event) {
      var rect = canvas.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var mouseY = event.clientY - rect.top;
      var index = Math.round((x / Math.max(1, rect.width)) * (points.length - 1));
      index = Math.max(0, Math.min(points.length - 1, index));
      var point = points[index];
      if (!point) {
        tooltip.style.opacity = "0";
        onHover({ index: null, layer: null, cumValue: null });
        return;
      }

      /*
      tooltip.textContent =
        dateFmt.format(new Date(point.ts)) +
        " - " +
        labels.btc +
        " " +
        pctFmt.format(point.btc) +
        "% | " +
        labels.eth +
        " " +
        pctFmt.format(point.eth) +
        "% | " +
        labels.stable +
        " " +
        pctFmt.format(point.stable) +
        "% | " +
        labels.others +
        " " +
        pctFmt.format(point.others) +
        "%";
*/
      tooltip.innerHTML =
        '<div class="cbd-tooltip-date">' + dateFmt.format(new Date(point.ts)) + "</div>" +
        '<div class="cbd-tooltip-row">' + labels.btc + ': <span>' + pctFmt.format(point.btc) + "%</span></div>" +
        '<div class="cbd-tooltip-row">' + labels.eth + ': <span>' + pctFmt.format(point.eth) + "%</span></div>" +
        '<div class="cbd-tooltip-row">' + labels.stable + ': <span>' + pctFmt.format(point.stable) + "%</span></div>" +
        '<div class="cbd-tooltip-row">' + labels.others + ': <span>' + pctFmt.format(point.others) + "%</span></div>";

      //tooltip.style.display = "block"; 
      //tooltip.style.opacity = "0";
      var realHeight = tooltip.offsetHeight;
      tooltip.style.opacity = "1";
      var selectedLayer = detectLayer(point, mouseY, rect);
      var selectedValue = point.btc;
      if (selectedLayer === "eth") {
        selectedValue = point.btc + point.eth;
      } else if (selectedLayer === "stable") {
        selectedValue = point.btc + point.eth + point.stable;
      } else if (selectedLayer === "others") {
        selectedValue = point.btc + point.eth + point.stable + point.others;
      }

      //var targetY = valueToY(selectedValue, rect);
      var pad = chartPad(rect.width);
      var plotWidth = rect.width - pad.left - pad.right;
      var pointX = pad.left + (index / Math.max(1, points.length - 1)) * plotWidth;
      var pointY = valueToY(selectedValue, rect);
      positionTooltip(tooltip, rect, pointX, pointY);
      //tooltip.style.opacity = "1";
      tooltip.style.visibility = "visible";
      //tooltip.style.visibility = "visible";
      //positionTooltip(tooltip, rect, x, targetY - 32);
      onHover({ index: index, layer: selectedLayer, cumValue: selectedValue });
    }

    function onLeave() {
      tooltip.style.opacity = "0";
      onHover({ index: null, layer: null, cumValue: null });
    }

    parent.onmousemove = onMove;
    parent.onmouseleave = onLeave;
  }

  function chartPad(width) {
    return {
      top: 16,
      right: width < 480 ? 36 : 44,
      bottom: 42,
      left: width < 480 ? 24 : 30,
    };
  }

  
function positionTooltip(tooltip, rect, pointX, pointY) {
    var tipWidth = tooltip.offsetWidth || 0;
    var tipHeight = tooltip.offsetHeight || 0;
    var arrowH = 7;
    var gap = 6;

    // 1. Смещаем влево: теперь точка X — это левый край (с небольшим отступом для стрелки)
    // Если нужно, чтобы стрелка была прямо над точкой, оставляем pointX.
    var left = pointX - 20; // 20px — это отступ, чтобы стрелка не была в самом углу

    // Ограничиваем, чтобы тултип не уходил за правый край экрана
    left = Math.max(8, Math.min(left, rect.width - tipWidth - 8));

    var top = pointY - tipHeight - arrowH - gap;
    if (!Number.isFinite(top)) {
        top = 0;
    }

    tooltip.style.left = left + "px";
    tooltip.style.top = top + "px";

    // 2. Рассчитываем положение стрелки относительно левого края тултипа
    var arrowLeft = pointX - left;
    
    // Зажимаем стрелку в пределах тултипа, чтобы она не вылетала за скругления углов
    arrowLeft = Math.max(16, Math.min(arrowLeft, tipWidth - 16));
    tooltip.style.setProperty("--arrow-offset", arrowLeft + "px");
}
/*
  function positionTooltip(tooltip, rect, pointX, pointY) {
    var tipWidth = tooltip.offsetWidth || 0;
    var tipHeight = tooltip.offsetHeight || 0;
    
    var arrowH = 8;
    var gap = 8;

    var left = pointX - tipWidth / 2;
    left = Math.max(8, Math.min(left, rect.width - tipWidth - 8));

    var top = pointY - tipHeight - arrowH - gap;
    top = Math.max(8, top);

    tooltip.style.left = left + "px";
    tooltip.style.top = top + "px";

    var arrowLeft = pointX - left;
    arrowLeft = Math.max(16, Math.min(arrowLeft, tipWidth - 16));
    tooltip.style.setProperty("--arrow-offset", arrowLeft + "px");
  }*/


  function latestShares(btcPct, ethPct, stablePct, othersPct) {
    var len = Math.min(btcPct.length, ethPct.length, stablePct.length, othersPct.length);
    for (var i = len - 1; i >= 0; i--) {
      if (
        btcPct[i] === null ||
        ethPct[i] === null ||
        stablePct[i] === null ||
        othersPct[i] === null
      ) {
        continue;
      }

      return {
        btc: Number(btcPct[i]) || 0,
        eth: Number(ethPct[i]) || 0,
        stable: Number(stablePct[i]) || 0,
        others: Number(othersPct[i]) || 0,
      };
    }
    return null;
  }

  function normalizeShares(input) {
    var btc = Math.max(0, input.btc || 0);
    var eth = Math.max(0, input.eth || 0);
    var stable = Math.max(0, input.stable || 0);
    var others = Math.max(0, input.others || 0);
    var total = btc + eth + stable + others;
    if (total <= 0) {
      return { btc: 0, eth: 0, stable: 0, others: 100 };
    }

    btc = (btc / total) * 100;
    eth = (eth / total) * 100;
    stable = (stable / total) * 100;
    others = 100 - btc - eth - stable;

    return { btc: btc, eth: eth, stable: stable, others: others };
  }

  function getShareLabels(lang) {
    var normalized = String(lang || "").toLowerCase();
    if (normalized === "ru") return { btc: "BTC", eth: "ETH", stable: "Стейблкоины", others: "Остальные" };
    if (normalized === "tr") return { btc: "BTC", eth: "ETH", stable: "Stablecoinler", others: "Digerleri" };
    if (normalized === "pl") return { btc: "BTC", eth: "ETH", stable: "Stablecoiny", others: "Pozostale" };
    if (normalized === "es") return { btc: "BTC", eth: "ETH", stable: "Stablecoins", others: "Otros" };
    if (normalized === "ro") return { btc: "BTC", eth: "ETH", stable: "Stablecoins", others: "Altele" };
    return { btc: "BTC", eth: "ETH", stable: "Stable", others: "Others" };
  }

  function assetLabel(lang, kind) {
    if (kind === "btc") return "Bitcoin";
    if (kind === "eth") return "Ethereum";
    return getShareLabels(lang)[kind] || kind;
  }

  function loadingText(lang) {
    var normalized = String(lang || "").toLowerCase();
    if (normalized === "ru") return "Загрузка...";
    if (normalized === "tr") return "Yukleniyor...";
    if (normalized === "pl") return "Ladowanie...";
    if (normalized === "es") return "Cargando...";
    if (normalized === "ro") return "Se incarca...";
    return "Loading...";
  }

  function showGraphMessage(graph, message) {
    teardownGraphResize(graph);
    var titleHtml = getGraphTitleHtml(graph);
    graph.classList.remove("cbd-graph--chart");
    graph.classList.remove("cbd-graph--donut");
    graph.innerHTML = titleHtml + '<p class="cbd-graph-fallback"></p>';
    var node = graph.querySelector(".cbd-graph-fallback");
    if (node) {
      node.textContent = message;
    }
  }

  function getNoDataText(graph) {
    if (!graph) {
      return "Data unavailable";
    }
    var node = graph.querySelector(".cbd-graph-fallback");
    if (!node || !node.textContent) {
      return "Data unavailable";
    }
    return node.textContent.trim();
  }

  function getGraphTitleHtml(graph) {
    if (!graph) {
      return "";
    }
    var titleNode = graph.querySelector(".cbd-graph-title");
    return titleNode ? titleNode.outerHTML : "";
  }

  function getNumberFormatter(locale, options) {
    var key = locale + "::" + JSON.stringify(options);
    if (!numberFormattersCache.has(key)) {
      numberFormattersCache.set(key, new Intl.NumberFormat(locale, options));
    }
    return numberFormattersCache.get(key);
  }

  function getDateTimeFormatter(locale, options) {
    var key = locale + "::" + JSON.stringify(options);
    if (!dateTimeFormattersCache.has(key)) {
      dateTimeFormattersCache.set(key, new Intl.DateTimeFormat(locale, options));
    }
    return dateTimeFormattersCache.get(key);
  }

  function bindChartResize(graph, draw) {
    teardownGraphResize(graph);

    if (typeof window.ResizeObserver === "function") {
      var resizeObserver = new ResizeObserver(function () {
        draw();
      });
      resizeObserver.observe(graph);
      graph._cbdResizeObserver = resizeObserver;
      return;
    }

    var onResize = function () {
      draw();
    };
    window.addEventListener("resize", onResize);
    graph._cbdOnResize = onResize;
  }

  function teardownGraphResize(graph) {
    if (!graph) {
      return;
    }

    if (graph._cbdResizeObserver) {
      graph._cbdResizeObserver.disconnect();
      graph._cbdResizeObserver = null;
    }

    if (typeof graph._cbdOnResize === "function") {
      window.removeEventListener("resize", graph._cbdOnResize);
      graph._cbdOnResize = null;
    }
  }
})();
